import { set } from "date-fns";
import { useEffect, useState } from "react";


interface UserLocation {
    latitude: number;
    longitude: number;
    accurancy: number | null;
    altitude: number | null;
    altitudeAccuracy: number | null;
    heading: number | null;
    speed: number | null;
}

interface GeolocationHookResult {
    location: UserLocation | null;
    error: string | null;
    loading: boolean;
    available: boolean;
}

const useGeolocation = (): GeolocationHookResult => {
    const [location, setLocation] = useState<UserLocation | null>(null)
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [available, setAvailable] = useState<boolean>(false);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError('Geolocation is not supported by your browser.');
            setLoading(false);
            return;
        }
        const successHandler = (position: GeolocationPosition) => {
            setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                accurancy: position.coords.accuracy,
                altitude: position.coords.altitude,
                altitudeAccuracy: position.coords.altitudeAccuracy,
                heading: position.coords.heading,
                speed: position.coords.speed,
            });
            setError(null); // Limpiar cualquier error previo
            setLoading(false);
        };

        const errorHandler = (geoError: GeolocationPositionError) => {
            let errorMessage: string;
            let available :boolean = true;
            switch (geoError.code) {
                case geoError.PERMISSION_DENIED:
                    errorMessage = 'User denied the request for Geolocation. Please enable location services for this site in your browser settings if you wish to use this feature.';
                    available = false;
                    break;
                case geoError.POSITION_UNAVAILABLE:
                    errorMessage = 'Location information is unavailable.';
                     available = false;
                    break;
                case geoError.TIMEOUT:
                    errorMessage = 'The request to get user location timed out.';
                     available = false;
                    break;
                default:
                    errorMessage = `Geolocation Error: ${geoError.message || 'Unknown error code'}`;
            }
            setError(errorMessage);
            setLocation(null); // Limpiar cualquier ubicación previa
            setLoading(false);
            setAvailable(available);
        };

        const options: PositionOptions = {
            enableHighAccuracy: false,
            timeout: 10000, // Aumentado a 10 segundos para dar más tiempo a la respuesta
            maximumAge: 0,
        };

        navigator.geolocation.getCurrentPosition(successHandler, errorHandler, options);

    }, []); 

    return { location, error, loading, available};

}

export default useGeolocation;